import { LocalizeService } from '../shared/utils/localize.service';

export function baseHrefFactory(localize: LocalizeService): string {
    const language = localize.getLanguage();

    return `/${language}`;
}
